import { z } from "zod";

const emptyStringToNull = (arg: string | null) => (arg ? arg : null);
const preprocessStringId = (arg: unknown) => {
    if (typeof arg === "string") {
        return arg.length > 0 ? Number(arg) : null;
    }
    return arg;
};

export const ContactFormSchema = z.object({
    emailAddress: z
        .string({
            invalid_type_error: "Invalid email address",
            required_error: "Email is required",
        })
        .email("Invalid email address"),
    displayName: z
        .string({
            invalid_type_error: "Invalid display name",
            required_error: "Display name is required",
        })
        .min(1, "Display name is required"),
    serviceId: z.preprocess(preprocessStringId, z.number().gt(0).nullable()),
    institutionId: z.preprocess(
        preprocessStringId,
        z.number().gt(0).nullable(),
    ),
    notes: z.string().nullable().transform(emptyStringToNull),
    phoneNumber: z.string().nullable().transform(emptyStringToNull),
    websiteUrl: z.string().nullable().transform(emptyStringToNull),
});

export type ContactFormSubmission = z.infer<typeof ContactFormSchema>;
export type FlattenedContactFormErrors = z.inferFlattenedErrors<
    typeof ContactFormSchema
>;
export type ContactFormFieldErrors = FlattenedContactFormErrors["fieldErrors"];
